import apiService from '../apiService'

export const comprehensiveController = configService => {
  const service = apiService(configService)
  const url = 'cms/buyer/offline-templates'

  return {
    getOffline: params => {
      return service.get({
        url: url,
        params,
      })
    },

    getOfflineID: id => {
      return service.get({
        url: url + `/${id}`,
      })
    },

    createOffline: params => {
      return service.post({
        url: url,
        params,
      })
    },

    updateOffline: params => {
      return service.put({
        url: url,
        params,
      })
    },

    deleteOffline: id => {
      return service.put({
        url: url + `/${id}/delete`,
      })
    },

    getGradeType: () => {
      return service.get({
        url: 'cms/buyer/offline-templates-grade-types',
      })
    },

    createOnline: params => {
      return service.post({
        url: 'cms/buyer/online-templates',
        params,
      })
    },

    checkBusinessType: (params, id) => {
      return service.post({
        url: 'cms/buyer/online-templates/check-business-type?group_id=' + id,
        params,
      })
    },

    getOnline: params => {
      return service.get({
        url: 'cms/buyer/online-templates',
        params,
      })
    },

    getOnlineID: (id, versionTemplate) => {
      return service.get({
        url:
          'cms/buyer/online-templates/' +
          id +
          '?version_template=' +
          versionTemplate,
      })
    },

    deleteOnline: id => {
      return service.put({
        url: 'cms/buyer/online-templates/delete/' + id,
      })
    },

    upLoadFileOnlineTemplate: formData => {
      return service.uploadFile({
        url: 'cms/buyer/file-online-assessments',
        formData,
      })
    },
    getRespond: (templateId, supplierId, versionResponded) => {
      return service.get({
        url:
          'cms/buyer/online-templates/respond/' +
          templateId +
          '/' +
          supplierId +
          '?version_answer=' +
          versionResponded,
      })
    },
    getOnlineComprehensiveID: (
      templateId,
      supplierId,
      versionResponded,
      versionTemplate
    ) => {
      return service.get({
        url:
          'cms/buyer/online-comprehensive/' +
          templateId +
          '/' +
          supplierId +
          '?version_answer=' +
          versionResponded +
          '&version_template=' +
          versionTemplate,
      })
    },

    downloadAnswerFile: id => {
      return service.downloadFile({
        url: `cms/buyer/supplier/answer/file-online-assessments/${id}/download`,
      })
    },

    downloadTemplateFile: id => {
      return service.downloadFile({
        url: `cms/buyer/template/file-online-assessments/${id}/download`,
      })
    },
  }
}

export const comprehensiveAssessmentController = configService => {
  const service = apiService(configService)
  const url = 'cms/buyer/offline-assessments'
  const urlDownload = 'cms/buyer/file-offline-assessments'
  return {
    getOfflineAssessmentID: (id, sortby) => {
      return service.get({
        url: `cms/buyer/mysupplier/${id}/offline-assessments?sort_by=${sortby}`,
      })
    },

    downloadAssessments: id => {
      return service.downloadFile({
        url: urlDownload + `/${id}/download`,
      })
    },

    updateOfflineAssessment: params => {
      return service.postFormData({
        url: url,
        params,
      })
    },
    getOnlineAssessmentID: id => {
      return service.get({
        url: `cms/buyer/online-templates/${id}/assessment`,
      })
    },
  }
}
